import React from 'react'

import style from './News.module.scss'

const New = () => {
	return <section className={style.news}>News</section>
}

export default New
